export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const getScrollBehavior = () => (prefersReducedMotion() ? 'auto' : 'smooth');

/**
 * Scroll to a section by id. Respects scroll-padding-top on <html> (nav offset).
 */
export const scrollToElementById = (id, options = {}) => {
  if (!id || typeof document === 'undefined') {
    return false;
  }

  const element = document.getElementById(id);
  if (!element) {
    return false;
  }

  const { updateHash = false, behavior = getScrollBehavior() } = options;

  element.scrollIntoView({
    behavior,
    block: 'start',
  });

  if (updateHash && typeof window !== 'undefined') {
    const nextHash = `#${id}`;
    if (window.location.hash !== nextHash) {
      window.history.replaceState(null, '', nextHash);
    }
  }

  return true;
};

export const scrollToTop = (options = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: options.behavior ?? getScrollBehavior(),
  });
};
